export const RecoginizeText = {
  "Title": "Recognize Text",
  "Settings": "Settings",
  "Supported": "Current Language Supported:",
  "Selected": "Selected languages(s):",
  "Searchable": "Searchable Text Image",
  "Editable": "Editable Text",
  "SearchableTip": {
    "Title": "Searchable Text Image",
    "Content": "The text can be searched but not allowed to be edited. The appearance of the PDF file will not change."
  },
  "EditableTip": {
    "Title": "Editable Text",
    "Content": "The PDF image text will be replaced with real text that can be edited with Foxit Editor Text & Paragraph Edit Content tool."
  },
  "FindAll": "Find All Suspect(Show all OCR results that may need to be changed.)",
  "RecognizeAsPach": "Recognize the line segments as path objects in the PDF",
  "Languages": {
    "Basque": "Basque",
    "Bulgarian": "Bulgarian",
    "Catalan": "Catalan",
    "Chinese-Simplified": "Chinese-Simplified",
    "Chinese-Traditional": "Chinese-Traditional",
    "Croatian": "Croatian",
    "Czech": "Czech",
    "Danish": "Danish",
    "Dutch": "Dutch",
    "English": "English",
    "Estonian": "Estonian",
    "Faeroese": "Faeroese",
    "Finnish": "Finnish",
    "French": "French",
    "Galician": "Galician",
    "German": "German",
    "Greek": "Greek",
    "Hebrew": "Hebrew",
    "Hungarian": "Hungarian",
    "Icelandic": "Icelandic",
    "Italian": "Italian",
    "Japanese": "Japanese",
    "Korean": "Korean",
    "Latvian(Lettish)": "Latvian (Lettish)",
    "Lithuanian": "Lithuanian",
    "Macedonian": "Macedonian",
    "Maltese": "Maltese",
    "Norwegian": "Norwegian",
    "Polish": "Polish",
    "Portuguese": "Portuguese",
    "Romanian": "Romanian",
    "Russian": "Russian",
    "Serbian": "Serbian",
    "Slovak": "Slovak",
    "Slovenian": "Slovenian",
    "Spanish": "Spanish",
    "Swedish": "Swedish",
    "Thai": "Thai",
    "Turkish": "Turkish",
    "Ukrainian": "Ukrainian"
  }
}